<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale/zh_CN";

export default {
  name: "App",
  data() {
    return {
      locale: zhCN
    };
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function() {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {}
};
</script>

<style lang="less">
html,
body,
#app {
  width: 100%;
  height: 100%;
  background: #FAFAFA;
  color: #333333;

  p {
    margin: 0;
  }

  ul,
  li {
    list-style: none;
  }

  .ant-table-tbody .ant-btn {
    margin: 0 2px;
  }
}

.h40 {
  input {
    height: 40px !important;
    line-height: 40px !important;
  }
}

.Input40 {
  height: 40px !important;
  line-height: 40px !important;
}

.ant-table-column-title {
  white-space: nowrap;
}

.page-header {
  background: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  padding: 24px;
  margin-top: 15px;
}

.shaDow {
  -webkit-box-shadow: 5px 8px 30px #bcbcbc;
  box-shadow: 5px 8px 30px #bcbcbc;
}

.page-main {
  background: #ffffff;
  padding: 24px;
  margin: 0 auto;
  margin-top: 15px;
}

.page-bg {
  background-color: #F6F7F8;
}

.ant-table-thead {
  .ant-table-column-title {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #3a3a3a;
    line-height: 22px;
  }
}

.ant-table-tbody > tr > td {
  color: #767676;
}

.title-p {
  font-size: 14px;
  font-weight: bold;
  padding: 10px 0;
}

.ant-modal-header {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #3a3a3a;
  line-height: 22px;
  border-bottom: none !important;
}

.ant-modal-footer {
  border-top: none !important;
}

.userStatistic {
  .numTip-wrap {
    display: flex;
    justify-content: center;
    text-align: center;

    .numTip {
      display: inline-block;
      //border: 1px solid #dcdcdc;
      //border-radius: 5px;
      padding: 5px 35px;
      font-size: 16px;
      margin: 20px !important;

      span {
        display: block;
        width: 100%;
      }

      .numTip-value {
        font-size: 26px;
        font-family: DINAlternate, DINAlternate-Bold;
        font-weight: 700;
        text-align: center;
        line-height: 30px;
        padding: 16px 0;
      }

      .numTip-name {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 20px;
      }
    }
  }
}

.home_page {
  .ant-menu-submenu-selected {
    .anticon {
      color: #0082FF
    }
  }

  .anticon {
    //font-size: 16px !important;
  }
}

.video-js .vjs-big-play-button {
  top: 50% !important;
  left: 50% !important;
  margin-left: -1.5em !important;
}
</style>
